﻿import React, { Fragment } from 'react';

import { Divider } from '../../../../../Resources/Scripts/_Shared/elements/Divider'
import { TwoColumnWrapper } from '../../../../../Resources/Scripts/_Shared/elements/ColumnWrapper'
import { DropdownlistWithLabel } from '../../../../../Resources/Scripts/_Shared/elements/DropdownlistWithLabel'

export const SpotSelection = ({ locale, children, productAvailability, maxAmount, spotSelection, formLang, pending, pendingAvailability, addSpotEvent, removeSpotEvent, incrementEvent, selectedDate }) => {
  children = React.Children.toArray(children);
  const emptyGuid = '00000000-0000-0000-0000-000000000000';

  const spotSelected = spotSelection.some(selection => selection.item.ParkingSpace.Uid !== emptyGuid);

  return (
    <Fragment>
      <Divider />
      {spotSelection.map((item, index) => {
        const notes = getNotes(item);
        return (
          <React.Fragment key={`single-spot-${index}`}>
            <TwoColumnWrapper>
              <DropdownlistWithLabel selectedDate={selectedDate} locale={locale} available={formLang.available} text={`${formLang.spotselection} ${index + 1}`} options={productAvailability ?? []} optionIdentifier="ParkingSpace.Uid" optionText="ParkingSpace.Name" value={item} setValue={addSpotEvent} index={index} disabled={pending || pendingAvailability || (removeSpotEvent !== null && (index + 1) !== spotSelection.length)} loading={!(removeSpotEvent !== null && (index + 1) !== spotSelection.length) && pendingAvailability} errorMessages={formLang.errorMessages}>
                {notes !== "" &&
                  <p>{notes}</p>
                }
              </DropdownlistWithLabel>
              {children[index]}
              {removeSpotEvent !== null && (index + 1) !== spotSelection.length &&
                <div className="single-step__section single-step__section--negativetopmargin">
                  <label className="single-step__section__label single-step__section__label--hideonphone">&nbsp;</label>
                <button className="single-step__link single-step__link--remove" disabled={pending} onClick={() => { removeSpotEvent(index) }}>Remove</button>
                </div>
              }
              {(index + 1) === spotSelection.length && 
                <div className={`single-step__section ${removeSpotEvent !== null && index > 0 && "single-step__section--space-between"}`}>
                {removeSpotEvent !== null && (index > 0) &&
                  <div>
                    <label className="single-step__section__label single-step__section__label--hideonphone">&nbsp;</label>
                    <button className="single-step__link single-step__link--remove" disabled={pending} onClick={() => { removeSpotEvent(index) }}>Remove</button>
                  </div>
                }
                  <div>
                    <label className="single-step__section__label single-step__section__label--hideonphone">&nbsp;</label>
                    {spotSelection.length < maxAmount?.number &&
                      <button className="single-step__button single-step__button--addspot" onClick={() => { incrementEvent() }} disabled={item.error || item.item.ParkingSpace.Uid === emptyGuid || pending || pendingAvailability}>{formLang.addspot}</button>
                    }
                  </div>
                </div>
              }
            </TwoColumnWrapper>
          </React.Fragment>
          )
        }
      )}
      {spotSelection.length === maxAmount?.number && spotSelected &&
        <div className="single-step__section">
          {/*<p>{maxAmount.type === 'product' ? formLang.exceededMaximumAmountInfo : formLang.exceededMaximumAmountADInfo}</p>*/}
          {spotSelection.length === maxAmount?.number && maxAmount?.type === 'product' && <p className="nomargin italic">{formLang.numberOfParkingSpotsInfo}</p>}
        </div>
      }
    </Fragment>
  )
}

const getNotes = (item) => {
  const thisItem = item?.item ?? item;
  const externalNote = thisItem?.ParkingSpace?.ExternalNote ?? "";
  const accessDeviceExternalNote = thisItem?.ParkingSpace?.AccessDeviceExternalNote ?? "";
  return externalNote + (externalNote !== "" ? " " : "") + accessDeviceExternalNote;
}